import type { RouteObject } from 'react-router-dom'

import { assemblyLoader } from './Assembly.loader'
import { ASSEMBLY_URL } from './assembly.navigator'
import Assembly from './Assembly.page'
import { missingLoader } from './missing/Missing.loader'
import { MISSING_URL } from './missing/Missing.navigator'
import MissingPage from './missing/Missing.page'
import { PALLET_DETAIL_URL } from './pallet-detail/PalletDetail.navigator'
import PalletDetailPage from './pallet-detail/PalletDetail.page'
import { palletsListLoader } from './pallets-list/PalletsList.loader'
import { PALLETS_LIST_URL } from './pallets-list/PalletsList.navigator'
import PalletsListPage from './pallets-list/PalletsList.page'
import { preparationLoader } from './preparation/Preparation.loader'
import { PREPARATION_URL } from './preparation/Preparation.navigator'
import PreparationPage from './preparation/Preparation.page'
import { productFormLoader } from './product-form/ProductForm.loader'
import { PRODUCT_FORM_URL } from './product-form/ProductForm.navigator'
import ProductFormPage from './product-form/ProductForm.page'
import { productsLoader } from './products/Products.loader'
import { PRODUCTS_URL } from './products/Products.navigator'
import ProductsPage from './products/Products.page'
import { SCAN_LOCATION_URL } from './scan-location/ScanLocation.navigator'
import ScanLocationPage from './scan-location/ScanLocation.page'
import { SCAN_PRINTER_URL } from './scan-printer/ScanPrinter.navigator'
import ScanPrinterPage from './scan-printer/ScanPrinter.page'
import { TEST_PRINTER_URL } from './test-printer/TestPrinter.navigator'
import TestPrinterPage from './test-printer/TestPrinter.page'
import { transferLoader } from './transfer/Transfer.loader'
import { TRANSFER_URL } from './transfer/Transfer.navigator'

import TransferPage from './transfer/Transfer.page'
import { transferDetailLoader } from './transfer-detail/TransferDetail.loader'

import { TRANSFER_DETAIL_URL } from './transfer-detail/TransferDetail.navigator'
import TransferDetailPage from './transfer-detail/TransferDetail.page'

export const assemblyRoutes: RouteObject[] = [
  {
    id: '(Assembly) Start Page',
    path: ASSEMBLY_URL,
    element: <Assembly />,
    loader: assemblyLoader
  },
  {
    id: '(Assembly) Transfer Detail',
    path: TRANSFER_DETAIL_URL,
    element: <TransferDetailPage />,
    loader: transferDetailLoader
  },
  {
    id: '(Assembly) Products',
    path: PRODUCTS_URL,
    element: <ProductsPage />,
    loader: productsLoader
  },
  {
    id: '(Assembly) Product Form',
    path: PRODUCT_FORM_URL,
    element: <ProductFormPage />,
    loader: productFormLoader
  },
  {
    id: '(Assembly) Missing',
    path: MISSING_URL,
    element: <MissingPage />,
    loader: missingLoader
  },
  {
    id: '(Assembly) Scan Printer',
    path: SCAN_PRINTER_URL,
    element: <ScanPrinterPage />
  },
  {
    id: '(Assembly) Test Printer',
    path: TEST_PRINTER_URL,
    element: <TestPrinterPage />
  },
  {
    id: '(Assembly) Scan Location',
    path: SCAN_LOCATION_URL,
    element: <ScanLocationPage />
  },
  {
    id: '(Assembly) Preparation',
    path: PREPARATION_URL,
    element: <PreparationPage />,
    loader: preparationLoader
  },
  {
    id: '(Assembly) Transfer',
    path: TRANSFER_URL,
    element: <TransferPage />,
    loader: transferLoader
  },
  {
    id: '(Assembly) Pallets List',
    path: PALLETS_LIST_URL,
    element: <PalletsListPage />,
    loader: palletsListLoader
  },
  {
    id: '(Assembly) Pallet Detail',
    path: PALLET_DETAIL_URL,
    element: <PalletDetailPage />
  }
]
